import animate from "./libs/animate";

/**
 * ScrollToSection Component
 *
 * @constructor
 */

export default function()
{
    const scrollers = document.querySelectorAll('[data-target-scroll]')

    scrollers.forEach(function(link) {
        link.addEventListener("click", function(e) {
            e.preventDefault()
            const targetData = link.getAttribute("data-target-scroll")
            const target = document.getElementById(targetData);
            animate(document.scrollingElement || document.documentElement, "scrollTop", "", document.documentElement.scrollTop, target.offsetTop, 500, true);
            return false
        })
    })

}

